import { render, staticRenderFns } from "./Informe.vue?vue&type=template&id=3f80ca4c"
import script from "./Informe.vue?vue&type=script&setup=true&lang=js"
export * from "./Informe.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports